module.exports = __webpack_public_path__ + "static/media/20190201_154012.37b76a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20190201_154012.jpg
// module id = 482
// module chunks = 0